import type { AdminModuleName } from '@/utils/adminModules';

export const DEFAULT_POLL_ADMIN_EMAIL = 'admin@digilogy.co';

export function getPollAdminEmails(): string[] {
  const emails = String(import.meta.env.VITE_POLL_ADMIN_EMAILS ?? '')
    .split(',')
    .map((email: string) => email.trim().toLowerCase())
    .filter(Boolean);
  if (!emails.includes(DEFAULT_POLL_ADMIN_EMAIL)) {
    emails.push(DEFAULT_POLL_ADMIN_EMAIL);
  }
  return emails;
}

export function isPollAdmin(
  _role?: string | null,
  email?: string | null,
  modules?: AdminModuleName[] | null,
): boolean {
  if ((modules ?? []).includes('POLLS')) return true;

  const candidateEmail = email?.trim().toLowerCase();
  if (!candidateEmail || !candidateEmail.includes('@')) return false;
  return getPollAdminEmails().includes(candidateEmail);
}

export const POLL_SUPER_ADMIN_EMAILS = [
  'admin@digilogy.co',
  'prathap.p@digilogy.co',
];

export function isPollSuperAdmin(email?: string | null): boolean {
  const candidateEmail = email?.trim().toLowerCase();
  if (!candidateEmail) return false;
  return POLL_SUPER_ADMIN_EMAILS.includes(candidateEmail);
}
